// Endereços vindos do .env do Vite (VITE_APP_*), um por ambiente.
export const config = Object.freeze({
  /** konq-admin-api: usuário, branding, tenants e capabilities */
  konqAdminApiUrl: import.meta.env.VITE_APP_KONQ_API_URL,
  /** konq-api: domínio do concurso */
  konqConcursoApiUrl: import.meta.env.VITE_APP_KONQ_CONCURSO_API_URL,
  /** Backoffice — destino do QR da ficha do produto (lido pelo operador) */
  backofficeUrl: import.meta.env.VITE_APP_BACKOFFICE_URL,
});
